if (!customElements.get('footer-accordion')) {
  class FooterAccordion extends HTMLElement {
    constructor() {
      super()
      this.mobileBreakpoint = '(max-width: 989px)';
    }

    connectedCallback() {
      this.attachEvents()
    }

    attachEvents() {
      window.addEventListener('load', () => {
        if (window.matchMedia(this.mobileBreakpoint).matches) {
          this.close()
        } else {
          this.open()
        }
      });
      window.addEventListener('resize', () => {
        if (window.matchMedia(this.mobileBreakpoint).matches) {
          if(!this.querySelector('details').hasAttribute('open')) {
            this.close()
          }
        } else {
          this.open()
        }
      });
    }

    close() {
      this.querySelector('details').removeAttribute('open');
    }

    open() {
      this.querySelector('details').setAttribute('open', true);
    }
  }

  customElements.define('footer-accordion', FooterAccordion)
}
